import React, { useState } from 'react';
import { Image, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    TopRated,
    LogoWrapper,
    AddressDetails,
    AddressList,
    AddressItem,
    ShareSocialLink,
    ShareList,
    ShareItem,
} from './claimNonprofitStyle'
import Top_logo from '../../../assests/images/badge-logo.png';
import Message_chat from '../../../assests/images/message-text.svg';
import Sms_icon from '../../../assests/images/sms.svg';
import Call_icon from '../../../assests/images/call-incoming.svg';
import Location from '../../../assests/images/linear-location.svg';
import Global from '../../../assests/images/global.svg';
import Facebook_blue from '../../../assests/images/facebook-blue.svg';
import Twitter_Icon from '../../../assests/images/xicon.svg';
import Heart from '../../../assests/images/red-heart.svg';
import NoFillHeart from '../../../assests/images/no-fill-heart.png';
import ClaimNonprofitModal from '../../common/modal/claimNonprofitModal';
import { useDispatch } from 'react-redux';
import { MESSAGE } from '../../../utils/message';
import { addEditFavioriteHandler, claimNonprofitHandler } from '../../../redux/slices/myNonprofit/editnonprofit-slice';

const ClaimNonprofit = ({ details, pageName = "" }: any) => {
    const [editClaimNonProfitOpen, setEditClaimNonProfitOpen] = useState(false);
    const [fav, setFav] = useState<boolean>(details?.is_favorite || false);
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId");
    const { pathname } = useLocation();
    const handleFav = () => {
        if (user_id && details?.id) {
            dispatch(addEditFavioriteHandler(user_id, details?.id));
            setFav((prevFav: boolean) => !prevFav);
        } else {
            handleClick()
        }
    };


    const handleClick = () => {
        if (typeof localStorage !== "undefined" && localStorage?.getItem("token")) {

            navigate(`${pathname}`)

        } else {
            typeof localStorage !== "undefined" && localStorage.setItem('reviewPath', `${pathname}`);
            navigate(`/signin`);
        }
    };

    const handleClaim = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        if (!user_id) {
            navigate('/signin');
        } else if (details?.id) {
            dispatch(claimNonprofitHandler(details?.id));
            setEditClaimNonProfitOpen(false);
        }
    }

    const handleClaimRedirect = () => {
        if (typeof localStorage !== "undefined" && localStorage?.getItem("token")) {
            setEditClaimNonProfitOpen(true)
        } else {
            typeof localStorage !== "undefined" && localStorage.setItem('reviewPath', `${pathname}`);
            navigate(`/signin`);
        }
    }

    return (
        <>
            <TopRated className='top-rated-wrap-box'>
                <LogoWrapper className='top-rated-logo'><Image src={Top_logo} /></LogoWrapper>
                <AddressDetails>
                    <AddressList>
                        {details?.ein &&
                            <AddressItem>
                                <>
                                    <span>
                                        <Image src={Message_chat} />
                                    </span>
                                    EIN {details.ein}
                                </>

                            </AddressItem>
                        }

                        {details?.org_email &&
                            <AddressItem onClick={() => window.open(`mailto:${details?.email}`)}>
                                <>
                                    <span>
                                        <Image src={Sms_icon} />
                                    </span>
                                    {details?.org_email}
                                </>
                            </AddressItem>}

                        {details?.phone &&
                            <AddressItem onClick={() => window.open(`tel:${details?.phone}`)}>
                                <>
                                    <span><Image src={Call_icon} /></span>
                                    {details?.phone}
                                </>
                            </AddressItem>}

                        <AddressItem>
                            <>
                                <span><Image src={Location} /></span>
                                {details?.address1 && `${details.address1}`}
                                {details?.address2 && `, ${details.address2}`}
                                {details?.city && `, ${details.city}`}
                                {details?.state && `, ${details.state}`}
                                {details?.country && `, ${details.country}`}
                                {details?.zipcode && `, ${details.zipcode}`}
                            </>
                        </AddressItem>


                        {details?.website &&
                            <AddressItem>
                                <>
                                    <span><Image src={Global} /></span>
                                    <Link to={`${details?.website}`} target="_blank">{details?.website}</Link>
                                </>
                            </AddressItem>}
                    </AddressList>
                    <ShareSocialLink>
                        <ShareList>
                            <ShareItem className="donation-social-media-btn">
                                <Link
                                    to={`https://www.facebook.com/share_channel/?link=${encodeURIComponent(details?.facebook_page)}&app_id=966242223397117&source_surface=external_reshare&display&hashtag`}
                                    target="_blank"
                                >
                                    <Image src={Facebook_blue} alt="Facebook" /> {MESSAGE.facebook}
                                </Link>

                                {/* <Link to={details?.facebook_page} target="_blank"><Image src={Facebook_blue} /> {MESSAGE.facebook}</Link> */}
                            </ShareItem>
                            <ShareItem className="donation-social-media-btn">
                                <Link to={details?.twitter_account} target="_blank"> <Image src={Twitter_Icon} /> {MESSAGE.twitter} </Link>
                            </ShareItem>
                            <ShareItem className='heart-button' onClick={handleFav}>
                                <Image src={fav ? Heart : NoFillHeart} alt='Heart Icon' />
                                {MESSAGE.addToFavBtn}
                            </ShareItem>
                        </ShareList>
                    </ShareSocialLink>
                    {pageName === "dashboard-profile" || details?.is_claimed ?
                        <Button className="btn-outline-success-blue" onClick={() => navigate(`/dashboard/edit/${details?.id}`)}> {MESSAGE.editNonprofitProfileBtn}</Button>
                        : <Button className="btn-outline-success-blue" onClick={() => handleClaimRedirect()}> {MESSAGE.claimThisNonprofitBtn}</Button>}
                </AddressDetails>
            </TopRated>
            <ClaimNonprofitModal editClaimNonProfitOpen={editClaimNonProfitOpen} setClaimNonprofitOpen={setEditClaimNonProfitOpen} confirmClaim={handleClaim} />
        </>

    )
}

export default ClaimNonprofit
